interface DeviceImageArrayType {
  device: string;
  code: string;
  listFileName: string;
  detailFileName: string;
  popUpFileName: string;
}

export const deviceImageArray: DeviceImageArrayType[] = [
  {
    device: "기타",
    code: `0`,
    listFileName: `list0.png`,
    detailFileName: `detail0.png`,
    popUpFileName: `MarkerPopUp0.png`,
  },
  {
    device: "트랙터",
    code: `1`,
    listFileName: `list1.png`,
    detailFileName: `detail1.png`,
    popUpFileName: `MarkerPopUp1.png`,
  },
  {
    device: "스피드스프레이어",
    code: `2`,
    listFileName: `list2.png`,
    detailFileName: `detail2.png`,
    popUpFileName: `MarkerPopUp2.png`,
  },
  {
    device: "사륜오토바이",
    code: `3`,
    listFileName: `list3.png`,
    detailFileName: `detail3.png`,
    popUpFileName: `MarkerPopUp3.png`,
  },
  {
    device: "이륜오토바이",
    code: `4`,
    listFileName: `list4.png`,
    detailFileName: `detail4.png`,
    popUpFileName: `MarkerPopUp4.png`,
  },
  {
    device: "1톤 트럭",
    code: `5`,
    listFileName: `list5.png`,
    detailFileName: `detail5.png`,
    popUpFileName: `MarkerPopUp5.png`,
  },
  {
    device: "보행관리기",
    code: `6`,
    listFileName: `list6.png`,
    detailFileName: `detail6.png`,
    popUpFileName: `MarkerPopUp6.png`,
  },
  {
    device: "승용관리기",
    code: `7`,
    listFileName: `list7.png`,
    detailFileName: `detail7.png`,
    popUpFileName: `MarkerPopUp7.png`,
  },
  {
    device: "농업용고소작업차",
    code: `8`,
    listFileName: `list8.png`,
    detailFileName: `detail8.png`,
    popUpFileName: `MarkerPopUp8.png`,
  },
  {
    device: "농업용운반차",
    code: `9`,
    listFileName: `list9.png`,
    detailFileName: `detail9.png`,
    popUpFileName: `MarkerPopUp9.png`,
  },
  {
    device: "농업용로더",
    code: `10`,
    listFileName: `list10.png`,
    detailFileName: `detail10.png`,
    popUpFileName: `MarkerPopUp10.png`,
  },
  {
    device: "승용예초기",
    code: `11`,
    listFileName: `list11.png`,
    detailFileName: `detail11.png`,
    popUpFileName: `MarkerPopUp11.png`,
  },
  {
    device: "승용제초기",
    code: `12`,
    listFileName: `list12.png`,
    detailFileName: `detail12.png`,
    popUpFileName: `MarkerPopUp12.png`,
  },
  {
    device: "승용이앙기",
    code: `13`,
    listFileName: `list13.png`,
    detailFileName: `detail13.png`,
    popUpFileName: `MarkerPopUp13.png`,
  },
  {
    device: "퇴비살포기",
    code: `14`,
    listFileName: `list14.png`,
    detailFileName: `detail14.png`,
    popUpFileName: `MarkerPopUp14.png`,
  },
  {
    device: "농약살포기",
    code: `15`,
    listFileName: `list15.png`,
    detailFileName: `detail15.png`,
    popUpFileName: `MarkerPopUp15.png`,
  },
  {
    device: "콤바인",
    code: `16`,
    listFileName: `list16.png`,
    detailFileName: `detail16.png`,
    popUpFileName: `MarkerPopUp16.png`,
  },
  {
    device: "굴삭기",
    code: `17`,
    listFileName: `list17.png`,
    detailFileName: `detail17.png`,
    popUpFileName: `MarkerPopUp17.png`,
  },
  {
    device: "경운기",
    code: `18`,
    listFileName: `list18.png`,
    detailFileName: `detail18.png`,
    popUpFileName: `MarkerPopUp18.png`,
  },
  {
    device: "잔가지파쇄기",
    code: `19`,
    listFileName: `list19.png`,
    detailFileName: `detail19.png`,
    popUpFileName: `MarkerPopUp19.png`,
  },
];
